import { LocationDescriptorObject } from 'history';
import qs from 'qs';

import { QueryParams } from '../types/url';

type ParsedQueryParams = Partial<Record<QueryParams, string>>;

export function getLocationQuery(
    location: LocationDescriptorObject,
): ParsedQueryParams {
    if (!location.search) {
        return {};
    }

    const { search } = location;

    return qs.parse(search.startsWith('?') ? search.substr(1) : search);
}

export function getReferrerQueries() {
    const referrer = document.referrer;
    if (!referrer) {
        return {};
    }
    const queriesStr = referrer.split('?')[1];

    return qs.parse(queriesStr);
}

export function getStringQuery(string: unknown) {
    if (typeof string !== 'string' || string.indexOf('?') === -1) return {};
    return qs.parse(string.split('?')[1]);
}

export function stringifyLocationQuery(
    query: Record<string, unknown>,
    options: Parameters<typeof qs.stringify>[1] = {},
) {
    return `?${qs.stringify(query, {
        arrayFormat: 'repeat',
        ...options,
    })}`;
}

/**
 * Add or set query params to a given URL
 */
export function updateQueryParamsPath(
    url: string,
    query: Record<string, unknown>,
): string {
    const [baseUrl, queryString] = url.split('?');
    const searchParams = new URLSearchParams(queryString || '');

    Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            searchParams.set(key, String(value));
        } else {
            searchParams.delete(key); // Optionally remove the param if value is null/undefined
        }
    });

    const updatedQueryString = searchParams.toString();
    return updatedQueryString ? `${baseUrl}?${updatedQueryString}` : baseUrl;
}

export function getPathnameWithQueryParams(
    path: string,
    queryParams: Partial<Record<QueryParams, string>> | Location['search'],
): string {
    if (!path) {
        return '';
    }

    if (typeof queryParams === 'string') {
        return path + queryParams;
    }

    const stringifiedQueryParams = Object.entries(queryParams || {})
        .filter(([_, value]) => value)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');

    return [path, stringifiedQueryParams].filter(Boolean).join('?');
}
